import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/LandingPage.module.css';

const sections = ['home', 'testimonials'];
const NAV_ICONS = { home: faHouse, testimonials: faQuoteRight };
const NAV_LABELS = { home: 'Home', testimonials: 'Results' };

export default function BottomNav({ active, onNav }) {
  return (
    <nav className={`${styles.heroNav} gyo-bottom-nav`}>
      <ul>
        {sections.map((id) => (
          <li key={id} data-anim>
            <button
              className={active === id ? styles.cur : undefined}
              onClick={() => onNav(id)}
              aria-label={NAV_LABELS[id]}
            >
              <FontAwesomeIcon className={styles.navIcons} icon={NAV_ICONS[id]} />
              <span className={styles.navLabel}>{NAV_LABELS[id]}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
